export const formatNumber = (
  num: number,
  format: 'marketcap' | 'value' = 'marketcap',
): string => {
  if (format === 'value') {
    return Math.floor(num).toLocaleString();
  }

  if (num >= 1e12) {
    return (num / 1e12).toFixed(1) + 'T';
  }
  if (num >= 1e9) {
    return (num / 1e9).toFixed(1) + 'B';
  }
  if (num >= 1e6) {
    return (num / 1e6).toFixed(1) + 'M';
  }
  if (num >= 1e3) {
    return (num / 1e3).toFixed(1) + 'K';
  }
  return num.toLocaleString();
};
